/**
 * DOM ids for the checkboxes in the slot filter modal.
 *
 * Location ids from Synops (1 = Gent, 2 = Gentbrugge, ...) and the weekday
 * keys ('1' = maandag, '2' = dinsdag, ...) overlap. When both were used as the
 * raw checkbox id, the label beside "maandag" pointed (via htmlFor) at the
 * "Gent" checkbox, so clicking the day label ticked a location (AZMM-2646).
 * Prefixing per group keeps every id on the page unique.
 */
export const filterLocationCheckboxId = (locationId: number | string) => `filter-location-${locationId}`

export const filterDayCheckboxId = (dayKey: number | string) => `filter-day-${dayKey}`
